<template>
  <div>
    <div class="banner">
      <img
        src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338"
        style="height:120px !important;"
      />
    </div>
    <section class="has-background-light" style="padding-bottom: 20px;">
      <br />
      <h1 class="title is-4">อัพเดทประกันภัย</h1>
    </section>
    <br />
    <div class="level-right">
      <div class="level-item">
        <p class="subtitle is-5"><strong>Frame No.</strong></p>
      </div>
      <div class="level-item">
        <div class="field has-addons">
          <p class="control">
            <input class="input" type="text" v-model="formSearch.frameNo" placeholder="กรุณาใส่หมายเลยตัวถัง" />
          </p>
          <p class="control">
            <button class="button" v-on:click="searchFrame">
              Search
            </button>
          </p>
        </div>
      </div>
    </div>
    <section v-if="chkData == true">
      <div class="hero-body-custom" >
        <div class="container">
          <div class="columns is-centered">
            <div class="column">
              <div class="container"><br>
                <div class="field">
                  <label class="label">บริษัทประกันภัย <span class="has-text-danger">*</span></label>
                  <div class="select">
                    <select v-model="form.Insurrance">
                      <option v-for="insurrance in insurrances" v-bind:key="insurrance" :value="insurrance" >{{ insurrance }}</option>
                    </select>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-two">
                    <div class="field">
                      <label class="label">วันเริ่มคุ้มครอง <span class="has-text-danger">*</span></label>
                      <div class="control">
                        <masked-input mask="11/11/1111" class="input" type="text" placeholder="วันเริ่มคุ้มครอง" v-model="form.startDate" /><br>
                        <small>eg: 12/05/2020</small>
                      </div>
                    </div>
                  </div>
                  <div class="column is-one-two">
                    <div class="field">
                      <label class="label">วันหมดอายุ <span class="has-text-danger">*</span></label>
                      <div class="control">
                        <masked-input mask="11/11/1111" class="input" type="text" placeholder="วันหมดอายุ" v-model="form.endDate" /><br>
                        <small>eg: 12/05/2020</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label class="label">เลขที่รับแจ้ง/เลขกรมธรรม์ <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <input class="input" type="text" placeholder="เลขที่รับแจ้ง/เลขกรมธรรม์" v-model="form.NoticeNo">
                  </div>
                </div>
                <div class="field">
                  <label class="label">ประเภทประกันภัย <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <input class="input" type="text" placeholder="ประเภทประกันภัย" v-model="form.insuranceType">
                  </div>
                </div>
                <div class="field">
                  <label class="label">ชื่อที่ปรึกษาการขายประกัน <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <input class="input" type="text" placeholder="ชื่อที่ปรึกษาการขายประกัน" v-model="form.consultName">
                  </div>
                </div>
                <br>
                <p v-if="errors.length">
                  <ul>
                    <li v-for="error in errors" v-bind:key="error" class="has-text-danger">{{ error }}</li>
                  </ul><br>
                </p>
                <button class="button is-success" v-on:click="submitform">{{ btn_action }}</button>
              </div>
            </div>
            <div class="column is-one-quarter">
              <div class="container">
                <br>
                <article class="panel is-primary">
                  <p class="panel-heading">
                    ข้อมูลรถยนต์
                  </p>
                  <!-- <p class="panel-block">
                    <span class="panel-icon">
                      <i class="fas fa-book" aria-hidden="true"></i>
                    </span>
                    ชื่อลูกค้า : {{formShow.customerName}}
                  </p>
                  <p class="panel-block">
                    <span class="panel-icon">
                      <i class="fas fa-book" aria-hidden="true"></i>
                    </span>
                    เบอร์โทร : {{formShow.customerName}}
                  </p> -->
                  <p class="panel-block">
                    <span class="panel-icon">
                      <i class="fas fa-car" aria-hidden="true"></i>
                    </span>
                    Moodel : {{formShow.Model}}
                  </p>
                  <p class="panel-block">
                    <span class="panel-icon">
                      <i class="fas fa-bars" aria-hidden="true"></i>
                    </span>
                    ทะเบียนรถ : {{formShow.licenseNo}}
                  </p>
                  <p class="panel-block">
                    <span class="panel-icon">
                      <i class="fas fa-bars" aria-hidden="true"></i>
                    </span>
                    Frame No. : {{formShow.frameNo}}
                  </p>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <section  v-if="!chkDataSave">
      <br><br><br><br><br><br><br>
      <div class="hero-body-custom" >
        <div class="container">
          <div class="columns is-centered">
            <div class="modal is-active">
                <div class="modal-background"></div>
                <div class="modal-content">
                  Update
                </div>
                <button class="modal-close is-large" aria-label="close"></button>
              </div>
          </div>
        </div>
      </div>
    </section> -->
    <section  v-if="chkData == false">
      <br><br><br><br><br><br><br>
      <div class="hero-body-custom" >
        <div class="container">
          <div class="columns is-centered">
            <progress class="progress is-primary" max="100">30%</progress>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style>
.hero-body-custom {
  display: flex;
  padding: 0 !important;
}
.banner {
  text-align: center;
  background-color: #000;
}
</style>
<style scoped>
small {
  font-size: 12px;
}
</style>
<script>
import QrcodeVue from 'qrcode.vue'
import MaskedInput from 'vue-masked-input'

export default {
  name: 'UpdateInsurance',
  components: {
    QrcodeVue,
    MaskedInput
  },
  data: () => ({
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    },
    errors: [],
    btn_action: 'Update',
    formSearch: {
      frameNo: ''
    },
    formShow: [],
    form: {
      Insurrance: '',
      startDate: '',
      endDate: '',
      NoticeNo: '',
      insuranceType: '',
      consultName: ''
    },
    id: '',
    insurrances: [
      '',
      'บริษัท กรุงเทพประกันภัย จำกัด (มหาชน)',
      'บริษัท ธนชาตประกันภัย จำกัด (มหาชน)',
      'บริษัท คุ้มภัยโตเกียวมารีนประกันภัย (ประเทศไทย) จำกัด (มหาชน)',
      'บริษัท ซมโปะ ประกันภัย (ประเทศไทย) จำกัด (มหาชน)',
      'บริษัท แอกซ่าประกันภัย จำกัด (มหาชน)',
      'บริษัท มิตซุย สุมิโตโม อินชัวร์รันซ์ จำกัด (สาขาประเทศไทย)',
      'บริษัท แอลเอ็มจี ประกันภัย จำกัด (มหาชน)',
      'บริษัท สินทรัพย์ประกันภัย จำกัด',
      'บริษัท สินมั่งคงประกันภัย จำกัด',
      'บริษัท เอ็ม เอส ไอ จี ประกันภัย จำกัด',
      'บริษัท ทิพยประกันภัย จำกัด (มหาชน)',
      'บริษัท วิริยะประกันภัย จำกัด (มหาชน)',
      'บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน)',
      'บริษัท อลิอันซ์ อยุธยา ประกันภัย จำกัด (มหาชน)',
      'บริษัท อาคเนย์ประกันภัย จำกัด (มหาชน)',
      'other'
    ],
    chkData: 'no',
    chkDataSave: false
  }),
  mounted () {},
  methods: {
    searchFrame () {
      let _this = this
      this.chkData = false
      // let params = {
      //   frameNo: this.formSearch.frameNo
      // }
      this.$axios
        .get(`${this.$apiUrl}getUpdateInsurance?frameNo=${this.formSearch.frameNo}`)
        .then(response => {
          console.log(response)
          let rs = response.data
          if (response.status === 200) {
            if (rs.length > 0) {
              this.chkData = true
              this.formShow = rs[0]
              // this.form = rs[0]
              // for (var i = 0; i < rs.length; i++) {

              // }
              const startDates = rs[0].startDate.split('/')
              const yearstart = String(startDates[2])
              const monthstart = String(parseInt(startDates[1]) + 100).substring(1)
              const daystart = String(parseInt(startDates[0]) + 100).substring(1)
              const endDates = rs[0].endDate.split('/')
              const yearend = String(endDates[2])
              const monthend = String(parseInt(endDates[1]) + 100).substring(1)
              const dayend = String(parseInt(endDates[0]) + 100).substring(1)
              _this.id = rs[0].id
              _this.form.Insurrance = rs[0].Insurrance
              _this.form.startDate = daystart + '/' + monthstart + '/' + yearstart
              _this.form.endDate = dayend + '/' + monthend + '/' + yearend
              _this.form.NoticeNo = rs[0].NoticeNo
              _this.form.insuranceType = rs[0].insuranceType
              _this.form.consultName = rs[0].consultName
            }
          }
        })
    },
    newCustomer () {
      this.form.Insurrance = ''
      this.form.NoticeNo = ''
      this.form.insuranceType = ''
      this.form.startDate = ''
      this.form.endDate = ''
      this.form.consultName = ''
      this.btn_action = 'Submit'
      this.errors = []
      this.formShow = []
      this.chkData = 'no'
    },
    checkForm (e) {
      if (this.form.Insurrance && this.form.startDate && this.form.endDate && this.form.NoticeNo && this.form.insuranceType && this.form.consultName) {
        return true
      }
      this.errors = []
      if (!this.form.Insurrance) {
        this.errors.push('กรุณากรอก บริษัทประกันภัย')
      }
      if (!this.form.startDate) {
        this.errors.push('กรุณากรอก วันเริ่มคุ้มครอง')
      }
      if (!this.form.endDate) {
        this.errors.push('กรุณากรอก วันสิ้นสุด')
      }
      if (!this.form.NoticeNo) {
        this.errors.push('กรุณากรอกเลขที่รับแจ้ง')
      }
      if (!this.form.insuranceType) {
        this.errors.push('กรุณากรอกประเภทประกันภัย')
      }
      if (!this.form.consultName) {
        this.errors.push('กรุณากรอกชื่อ ที่ปรึกษาการขาย')
      }
      e.preventDefault()
    },
    submitform (e) {
      let _this = this
      if (!this.checkForm(e)) {
        return false
      }
      _this.btn_action = 'Waiting...'
      // let params = {
      //   form: _this.form
      // }
      // console.log(params)
      this.$axios
        .post(`${this.$apiUrl}insuraneUpdate?id=${_this.id}`, _this.form)
        .then(response => {
          this.newCustomer()
          alert('Update Success')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UpdateInsurance.vue